const screenDimension = () => {
  if (typeof document === 'undefined') return;

  return {
    height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
    width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
  };
};

const windowResize = callback => {
  if (typeof window === 'undefined') return;

  let running = false;

  function runCallback() {
    callback(screenDimension());
    running = false;
  }

  const callback_ = () => {
    if (!running) {
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(runCallback);
      } else {
        setTimeout(runCallback, 66);
      }

      running = true;
    }
  };
  window.addEventListener('resize', callback_);

  return () => window.removeEventListener('resize', callback_);
};

export default windowResize;
